module.exports = __webpack_public_path__ + "8bfd547b9a8aff61c7a74979630f7cc1.svg";